
import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import ProductsSection from './components/ProductsSection';
import CTASection from './components/CTASection';

export default function Home() {
  useEffect(() => {
    // Add Schema.org JSON-LD
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "XJ Global",
      "url": import.meta.env.VITE_SITE_URL || "https://example.com",
      "logo": `${import.meta.env.VITE_SITE_URL || "https://example.com"}/logo.png`,
      "description": "Leading sourcing, product development and supply chain management company for the world's largest retail chain stores and brands.",
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+1-555-0123",
        "contactType": "Customer Service",
        "email": "info@xj-global.com"
      },
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Global Operations",
        "addressCountry": "US"
      },
      "sameAs": [
        "https://www.xj-beauty.com",
        "https://www.xj-battery.com"
      ],
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Supply Chain Services",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Product Sourcing",
              "description": "Comprehensive product sourcing solutions for global retail chains"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Supply Chain Management",
              "description": "End-to-end supply chain management and logistics solutions"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Product Development",
              "description": "Custom product development and manufacturing services"
            }
          }
        ]
      }
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <ProductsSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
